import { Stack } from '@mui/material';

import {
  MetricBarChart,
  MetricCardProps,
  MetricPanel,
  MetricTimePoint,
} from '@occc/ui-design-system';

type RetailerNetworkLoyaltyPerformanceProps = {
  totalMetrics: MetricCardProps[];
  loyaltyMetrics: MetricCardProps[];
  loyaltyTitle?: string;
  salesMetrics: MetricCardProps[];
  transactionsTimeSeries: MetricTimePoint[];
};

export const RetailerNetworkLoyaltyPerformance = ({
  totalMetrics,
  loyaltyMetrics,
  loyaltyTitle = 'Loyalty',
  salesMetrics,
  transactionsTimeSeries,
}: RetailerNetworkLoyaltyPerformanceProps) => {
  return (
    <Stack gap={1} mb={8}>
      <MetricPanel metrics={totalMetrics}>
        <MetricBarChart metrics={transactionsTimeSeries} />
      </MetricPanel>
      <MetricPanel title={loyaltyTitle} metrics={loyaltyMetrics} />
      <MetricPanel title='Sales Volume' metrics={salesMetrics} />
    </Stack>
  );
};
